import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 mb-20" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "card-title fw-black mb-0" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_9 = { class: "m-2" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-3 d-flex justify-content-start mb-1 mb-md-0" }
const _hoisted_12 = { class: "col-md-9" }
const _hoisted_13 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_18 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_19 = { class: "text-nowrap" }
const _hoisted_20 = { style: {"color":"#ff9f43"} }
const _hoisted_21 = { key: 5 }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_25 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_26 = { class: "m-2" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-3 d-flex justify-content-start mb-1 mb-md-0" }
const _hoisted_29 = {
  cols: "12",
  md: "9"
}
const _hoisted_30 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "d-flex align-items-center" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_35 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_36 = { class: "text-nowrap" }
const _hoisted_37 = { style: {"color":"#ff9f43"} }
const _hoisted_38 = { key: 5 }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.virement.ref), 1),
            _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("p", null, [
              _cache[10] || (_cache[10] = _createTextVNode(" Date de création : ", -1)),
              (_ctx.virement.created_at)
                ? (_openBlock(), _createElementBlock("b", _hoisted_6, _toDisplayString(_ctx.getDate(_ctx.virement.created_at)), 1))
                : _createCommentVNode("", true),
              _cache[11] || (_cache[11] = _createTextVNode(" | ", -1)),
              _createElementVNode("b", null, _toDisplayString(_ctx.virement?.c_by_name), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h5", null, "Factures enregistrées")
      ], -1)),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_ctx.virement.statut === 0 && _ctx.auth.can('ADD_VIREMENT'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    style: {"margin-right":"12px"},
                    class: "btn btn-success",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.AddNewColis && _ctx.AddNewColis(...args)))
                  }, " Ajouter"))
                : _createCommentVNode("", true),
              _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_v_select, {
                modelValue: _ctx.users.per_page,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.users.per_page) = $event)),
                options: [10, 50],
                clearable: false,
                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getRecords1()))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.users.searchTerm) = $event)),
                      placeholder: "Chercher",
                      type: "text",
                      class: "form-control",
                      onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getRecords1()))
                    }, null, 544), [
                      [_vModelText, _ctx.users.searchTerm]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows1,
          "select-options": {
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'facture Sélectionées',
          disableSelectInfo: true,
          selectAllByGroup: true,
        },
          responsive: "",
          onSelectAll: _ctx.onSelectAll,
          onSelectedRowsChange: _ctx.selectionChanged
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [
                _createTextVNode("Aucune entrées correspondants trouvés", -1)
              ])),
              _: 1,
              __: [14]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'invoice_ref')
              ? (_openBlock(), _createElementBlock("b", _hoisted_16, _toDisplayString(props.row.invoice_ref), 1))
              : (props.column.field === 'total_to_send')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("b", null, _toDisplayString(props.row.total_to_send), 1),
                    _cache[15] || (_cache[15] = _createTextVNode(" DH ", -1))
                  ], 64))
                : (props.column.field === 'parcels_num')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("b", null, _toDisplayString(props.row.parcels_num), 1),
                      _cache[16] || (_cache[16] = _createTextVNode(" Colis ", -1))
                    ], 64))
                  : (props.column.field === 'created_at')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (props.row.created_at)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                              _createTextVNode(_toDisplayString(_ctx.getDate(props.row.created_at)), 1),
                              _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(" " + _toDisplayString(props.row.create_by_name), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_18))
                      ], 64))
                    : (props.column.field === 'customer_name')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          _createElementVNode("b", null, _toDisplayString(props.row.client?.store ?? ''), 1),
                          _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("p", _hoisted_19, [
                            _createTextVNode(_toDisplayString(props.row.client?.bank ?? ''), 1),
                            _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("span", _hoisted_20, _toDisplayString(props.row.client?.rib ?? ''), 1)
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "onSelectAll", "onSelectedRowsChange"]),
        _createElementVNode("div", _hoisted_22, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-md-6" }, null, -1)),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_PaginatorContent, {
              pagination: _ctx.users,
              offset: 9,
              onPaginate: _ctx.getRecords1
            }, null, 8, ["pagination", "onPaginate"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _cache[30] || (_cache[30] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h5", null, "Factures ajoutées")
      ], -1)),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              (_ctx.virement.statut === 0 && _ctx.auth.can('ADD_VIREMENT'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    style: {"margin-right":"12px"},
                    class: "btn btn-danger",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.RemoveNewColis && _ctx.RemoveNewColis(...args)))
                  }, " Supprimer"))
                : _createCommentVNode("", true),
              _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_v_select, {
                modelValue: _ctx.users2.per_page,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.users2.per_page) = $event)),
                options: [10, 50],
                clearable: false,
                onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getRecords2()))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.users2.searchTerm) = $event)),
                      placeholder: "Chercher",
                      type: "text",
                      class: "form-control",
                      onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getRecords2()))
                    }, null, 544), [
                      [_vModelText, _ctx.users2.searchTerm]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows2,
          "select-options": {
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        },
          responsive: "",
          onSelectAll: _ctx.onSelectAllColis,
          onSelectedRowsChange: _ctx.selectionChangedColis
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[23] || (_cache[23] = [
                _createTextVNode("Aucune entrées correspondants trouvés", -1)
              ])),
              _: 1,
              __: [23]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'invoice_ref')
              ? (_openBlock(), _createElementBlock("b", _hoisted_33, _toDisplayString(props.row.invoice_ref), 1))
              : (props.column.field === 'total_to_send')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("b", null, _toDisplayString(props.row.total_to_send), 1),
                    _cache[24] || (_cache[24] = _createTextVNode(" DH ", -1))
                  ], 64))
                : (props.column.field === 'parcels_num')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("b", null, _toDisplayString(props.row.parcels_num), 1),
                      _cache[25] || (_cache[25] = _createTextVNode(" Colis ", -1))
                    ], 64))
                  : (props.column.field === 'created_at')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (props.row.created_at)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                              _createTextVNode(_toDisplayString(_ctx.getDate(props.row.created_at)), 1),
                              _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(" " + _toDisplayString(props.row.create_by_name), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_35))
                      ], 64))
                    : (props.column.field === 'customer_name')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          _createElementVNode("b", null, _toDisplayString(props.row.client?.store ?? ''), 1),
                          _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("p", _hoisted_36, [
                            _createTextVNode(_toDisplayString(props.row.client?.bank ?? ''), 1),
                            _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("span", _hoisted_37, _toDisplayString(props.row.client?.rib ?? ''), 1)
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "onSelectAll", "onSelectedRowsChange"]),
        _createElementVNode("div", _hoisted_39, [
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "col-md-6" }, null, -1)),
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_PaginatorContent, {
              pagination: _ctx.users2,
              offset: 9,
              onPaginate: _ctx.getRecords2
            }, null, 8, ["pagination", "onPaginate"])
          ])
        ])
      ])
    ])
  ], 64))
}